// Matches the fallback already used by the existing chat components
// (createNewGroup.js, editGroup.js, etc.) — the RN app's noimage.png host
// (nemonto.s3.amazonaws.com) 403s, this one resolves.
export const NO_IMAGE = 'https://uzone360live.s3.amazonaws.com/noimage.png';

// user_data in redux is stored as a JSON string, and its shape has varied
// between {user: {...}} (auth responses) and a flat user record depending on
// call site — check both so callers get a working id/user regardless.
export const getCurrentUser = (userDataRaw) => {
  if (!userDataRaw) return null;
  let parsed = userDataRaw;
  if (typeof userDataRaw === 'string') {
    try {
      parsed = JSON.parse(userDataRaw);
    } catch (e) {
      return null;
    }
  }
  return parsed?.user || parsed || null;
};

export const fullName = (user) =>
  [user?.first_name, user?.last_name].filter(Boolean).join(' ') || 'Unknown';

export const formatChatTime = (isoDate) => {
  if (!isoDate) return '';
  const d = new Date(isoDate);
  const now = new Date();
  const isToday = d.toDateString() === now.toDateString();
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  if (isToday) return time;
  return `${d.toLocaleDateString([], { month: 'short', day: 'numeric' })} ${time}`;
};
